import { connect } from 'react-redux'
import Table from './Table'

import onChangeTable from './Handlers/onChangeTable'

const mapStateToProps = (state) => ({
  subOrders: state.screens.SubOrders.subOrders,
  fetching: state.screens.SubOrders.fetching,
  pagination: state.screens.SubOrders.pagination,
})

const actionCreators = {
  onChangeTable,
}

export default connect(mapStateToProps, actionCreators)(Table)
